module.exports = __webpack_public_path__ + "static/media/syncui_120.79b6d7e0.ico";